import React from "react";
import "./style.less";
import { Icon } from "semantic-ui-react";

function ToastMessages({ appearance, children }) {
  return (
    <div className={`ToastMessages ${appearance}`}>
      <span>{children}</span>
      <Icon name="close" />
    </div>
  );
}

export default ToastMessages;
